var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-popup-menu-button c-disclosure-button",attrs:{"title":"popup menu"},on:{"click":_vm.showMenuItems}})}
var staticRenderFns = []

export { render, staticRenderFns }